 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXTHTIT from '@/components/Text/htit'
 import TEXTBOOKS_BY from '@/components/Text/books_by'
 import LOVE_1 from '@/components/love_1'
 import TEXTTITLE from '@/components/Text/title'
 import TEXTCRT from '@/components/Text/crt'
 import TEXTFM from '@/components/Text/fm'
 import TEXTHOW_TO from '@/components/Text/how_to'
 import TEXTTOC from '@/components/Text/toc'
 import TEXTINTRODUCTION from '@/components/Text/introduction'
 import TEXTCHAP1 from '@/components/Text/chap1'
 import TEXTCHAP2 from '@/components/Text/chap2'
 import TEXTCHAP3 from '@/components/Text/chap3'
 import LOVE_2 from '@/components/love_2'
 import TEXTCHAP4 from '@/components/Text/chap4'
 import TEXTINDEX from '@/components/Text/index'
 import TEXTABT from '@/components/Text/abt'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/cover",
 			"name" : "Text/cover",
 			"component" : TEXTCOVER
 		},
 		{
 			"path" : "/Text/htit",
 			"name" : "Text/htit",
 			"component" : TEXTHTIT
 		},
 		{
 			"path" : "/Text/books_by",
 			"name" : "Text/books_by",
 			"component" : TEXTBOOKS_BY
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Text/title",
 			"name" : "Text/title",
 			"component" : TEXTTITLE
 		},
 		{
 			"path" : "/Text/crt",
 			"name" : "Text/crt",
 			"component" : TEXTCRT
 		},
 		{
 			"path" : "/Text/fm",
 			"name" : "Text/fm",
 			"component" : TEXTFM
 		},
 		{
 			"path" : "/Text/how_to",
 			"name" : "Text/how_to",
 			"component" : TEXTHOW_TO
 		},
 		{
 			"path" : "/Text/toc",
 			"name" : "Text/toc",
 			"component" : TEXTTOC
 		},
 		{
 			"path" : "/Text/introduction",
 			"name" : "Text/introduction",
 			"component" : TEXTINTRODUCTION
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js